import React, { createContext, useState, useContext, useCallback } from 'react';
import { setLocalUser, getToken } from '../../../Config/ApiConfig';

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {});
  const [token, setToken] = useState(getToken() || '');

  const handleChangeUser = useCallback((userOrFn) => {
    if (typeof userOrFn === 'function') {
      setUser(prevUser => {
        const newUser = userOrFn(prevUser);
        setLocalUser(newUser);
        return newUser;
      });
    } else {
      setLocalUser(userOrFn);
      setUser(userOrFn);
    }
  }, []);

  const handleTokenChange = useCallback((newToken) => {
    setToken(newToken);
  }, []);
  
  // Update token when localStorage changes
  window.addEventListener('user-data-change', () => {
    const currentToken = getToken();
    if (currentToken !== token) {
      setToken(currentToken || '');
    }
  });
  
  return (
    <GlobalContext.Provider value={{ 
      loading, 
      setLoading, 
      user, 
      changeUser: handleChangeUser,
      token,
      setToken: handleTokenChange
    }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);